import { useState, useEffect } from 'react'

// Components
import { Button, IconCheck, IconPen } from '@tracklib/kit'
import { Input } from 'components/form/inputs'

// Utils
import styles from './email.css'

type EmailProps = {
  onReview: boolean
  email?: string
  emailKey: string
}

const validateEmail = (value: string) => {
  let error
  if (!value) {
    error = 'Your Email is required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = 'Invalid email address'
  }
  return error
}

const Email = (props: EmailProps): JSX.Element => {
  const { onReview, email, emailKey } = props
  const [isEditing, setIsEditing] = useState(true)

  useEffect(() => {
    if (onReview) {
      setIsEditing(false)
    }
  }, [onReview])

  if (!isEditing) {
    return (
      <div className={styles.displayWrapper}>
        <div className={styles.textData}>{email}</div>
        {onReview && !isEditing && (
          <Button className={styles.btnEdit} variant="outline" onClick={() => setIsEditing(!isEditing)}>
            <IconPen />
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className={styles.editingWrapper}>
      <Input
        className={styles.inputField}
        id={`${emailKey}_email`}
        name={`${emailKey}_email`}
        type="email"
        autoComplete="email"
        validate={validateEmail}
      />
      {onReview && isEditing && (
        <Button className={styles.btnEditConfirm} onClick={() => setIsEditing(!isEditing)}>
          <IconCheck />
        </Button>
      )}
    </div>
  )
}

export default Email
